/** Backlog #53: counts of things waiting for you, keyed by page path (e.g. "/workforce/time-off": 2). */
export interface NavBadges { items: Record<string, number>; generated_at: string }

/** t139: departments, groups and people you follow (Home sidebar). Buildings use their own follow. */
export interface NavFollows {
  teams: { id: string; name: string; kind: 'department' | 'group' }[];
  people: { user_id: string; display_name: string }[];
}
export type NavFollowType = 'team' | 'person';

/** t607u: a page you saved to My Shortcuts (Home sidebar, desktop). Personal: one list per person per workspace. */
export interface UserShortcut { id: string; path: string; label: string; position: number; created_at: string }
export interface UserShortcuts { shortcuts: UserShortcut[] }
/** Most shortcuts one person can keep in a workspace, and the longest label and path. */
export const SHORTCUTS_MAX = 30;
export const SHORTCUT_LABEL_MAX = 80;
export const SHORTCUT_PATH_MAX = 500;

/**
 * t607u: the in-app route a shortcut stores: path and query string, no hash, query keys sorted so the same page always
 * matches. Null when it isn't an in-app path (absolute URLs, protocol-relative, control characters, too long).
 */
export function normaliseShortcutPath(raw: string): string | null {
  if (typeof raw !== 'string') return null;
  const s = raw.trim().split('#')[0];
  if (!s.startsWith('/') || s.startsWith('//') || s.includes('\\') || [...s].some(c => c.charCodeAt(0) <= 32 || c.charCodeAt(0) === 127)) return null;
  const q = s.indexOf('?');
  const pathname = (q < 0 ? s : s.slice(0, q)).replace(/(.)\/+$/, '$1');
  const params = new URLSearchParams(q < 0 ? '' : s.slice(q + 1));
  const entries = [...params.entries()].filter(([k]) => k !== '').sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
  const search = new URLSearchParams(entries).toString();
  const out = search ? `${pathname}?${search}` : pathname;
  return out.length > SHORTCUT_PATH_MAX ? null : out;
}

/** t607u: a label as saved: trimmed, inner whitespace collapsed, cut to the maximum. */
export const cleanShortcutLabel = (raw: string) => (typeof raw === 'string' ? raw.replace(/\s+/g, ' ').trim().slice(0, SHORTCUT_LABEL_MAX) : '');
